export default function VideoSection() {
  const videos = [
    {
      title: 'Hawaii Roadtrip Experience',
      description: 'Trải nghiệm lái xe xuyên qua các đảo Hawaii tuyệt đẹp',
      thumbnail: 'https://public.readdy.ai/ai/img_res/7ee058a10d7f323a37b43fc3d4bce690.jpg',
      icon: 'ri-roadster-line',
      link: 'https://youtu.be/K-LGYYl9kas?si=hWpjZ_jeQuB98X8X'
    },
    {
      title: 'Lái xe dọc bờ biển',
      description: 'Cung đường ven biển đẹp nhất Hawaii với xe mui trần',
      thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20coastal%20drive%20in%20Hawaii%20with%20car%20on%20winding%20ocean%20road%2C%20dramatic%20sea%20cliffs%2C%20crashing%20waves%2C%20blue%20Pacific%20Ocean%2C%20scenic%20highway%2C%20professional%20travel%20video%20thumbnail%2C%20simple%20ocean%20background&width=800&height=450&seq=video-thumb-2&orientation=landscape',
      icon: 'ri-car-line'
    },
    {
      title: 'Núi lửa & Thiên nhiên',
      description: 'Khám phá công viên núi lửa và dung nham đỏ rực',
      thumbnail: 'https://readdy.ai/api/search-image?query=Active%20volcano%20in%20Hawaii%20with%20glowing%20lava%20flows%20at%20night%2C%20volcanic%20crater%2C%20molten%20lava%2C%20dramatic%20geological%20landscape%2C%20professional%20nature%20documentary%20thumbnail%2C%20simple%20volcanic%20background&width=800&height=450&seq=video-thumb-3&orientation=landscape',
      icon: 'ri-fire-line'
    },
    {
      title: 'Flycam Hana Road',
      description: 'Góc nhìn từ trên cao cung đường Hana lãng mạn',
      thumbnail: 'https://readdy.ai/api/search-image?query=Aerial%20drone%20view%20of%20Road%20to%20Hana%20Maui%2C%20winding%20coastal%20road%20through%20lush%20tropical%20rainforest%2C%20waterfalls%2C%20dramatic%20ocean%20views%2C%20professional%20aerial%20videography%20thumbnail%2C%20simple%20forest%20background&width=800&height=450&seq=video-thumb-4&orientation=landscape',
      icon: 'ri-flight-takeoff-line',
      link: 'https://www.youtube.com/watch?v=_yxfpv8MnXs'
    },
    {
      title: 'Polynesian Cultural Show',
      description: 'Màn trình diễn văn hóa Polynesia đặc sắc',
      thumbnail: 'https://readdy.ai/api/search-image?query=Polynesian%20cultural%20performance%20in%20Hawaii%20with%20fire%20dancers%2C%20traditional%20costumes%2C%20tropical%20stage%20setting%2C%20evening%20show%2C%20professional%20event%20videography%20thumbnail%2C%20simple%20stage%20background&width=800&height=450&seq=video-thumb-5&orientation=landscape',
      icon: 'ri-music-2-line'
    },
    {
      title: 'Underwater Hawaii',
      description: 'Thế giới dưới nước tuyệt đẹp của Hawaii',
      thumbnail: 'https://readdy.ai/api/search-image?query=Underwater%20scene%20in%20Hawaii%20with%20colorful%20coral%20reefs%2C%20tropical%20fish%2C%20sea%20turtles%2C%20crystal%20clear%20turquoise%20water%2C%20snorkeling%20view%2C%20professional%20underwater%20videography%20thumbnail%2C%20simple%20ocean%20background&width=800&height=450&seq=video-thumb-6&orientation=landscape',
      icon: 'ri-water-flash-line'
    }
  ];

  const handleVideoClick = (link?: string) => {
    if (link) {
      window.open(link, '_blank');
    }
  };

  return (
    <section id="video" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Video <span className="text-[#2563eb]">trải nghiệm</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Cảm nhận hành trình Hawaii qua những thước phim tuyệt đẹp
          </p>
        </div>

        {/* Video Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {videos.map((video, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              onClick={() => handleVideoClick(video.link)}
            >
              {/* Thumbnail */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={video.thumbnail}
                  alt={video.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors duration-300"></div>
                
                {/* Play Button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-xl">
                    <i className="ri-play-fill text-[#2563eb] text-3xl ml-1"></i>
                  </div>
                </div>

                {/* Icon Badge */}
                <div className="absolute top-4 right-4 w-10 h-10 bg-white/90 backdrop-blur-sm rounded-lg flex items-center justify-center">
                  <i className={`${video.icon} text-[#2563eb] text-xl`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{video.title}</h3>
                <p className="text-gray-600 leading-relaxed">{video.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="#testimonials"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Xem trải nghiệm video
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
